export default __webpack_public_path__ + "static/media/Telephone.9317fcf7.png";